import { merge } from 'lodash';

import config from './central-app-env';


angular.module('bootstrap').constant('ConfigApp', merge({
    UrlApi: "https://localhost:44341/ccgp/api",
    UrlBase: "https://localhost:44341/ccgp",
    CentralAppId: 'BA69D4DB-2657-4152-9E30-038B686E3E66',
    CentralServicoModuloId: 'F66F079C-5896-4AF2-B7D9-8060D80DDD71',
    UrlLogin: '#/login',
    UrlCstiApi: 'https://csti.projecao.br/api',
    CstiApiId: '02C7115C-E385-406C-8BBE-9015FC5CECF0',
    LinkFoto: function( login, tamanho ){

        var dimensao = tamanho || '240x240';

        // https://webmail.projecao.br/ews/exchange.asmx/s/GetUserPhoto?email=usuario.login@projecao.br&size=HR240x240
        return 'https://webmail.projecao.br/ews/exchange.asmx/s/GetUserPhoto?email='+ login +'@projecao.br&size=HR' + dimensao
    }
}, config[process.env.NODE_ENV]))




// WEBPACK FOOTER //
// ./src/core/config/central-constant.js